module.exports = __webpack_public_path__ + "static/img/bangding.a03b6b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view10/bangding.png
// module id = 0mhh
// module chunks = 1